import { Form, Formik, FormikProps } from 'formik';
import { useHistory } from 'react-router';
import { Grid, Hidden } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '@cpg-its/ads.containers.banner';
import { GuidedProcessSupportBlock } from '../../../../../../global/components/guided-process-support-block';
import { DemographicsContext } from '../../../../../../global/models/demographics-model';
import { PageHeader } from '../../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../../global/components/layout/sidebar-content';
import { LabelSettingProps } from '../../../../../../global/models/epi-model';
import { Person } from '../../../../../../global/models/person-model';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { AnnualEnrollmentProps, NewHireProps } from '../../../../models/arc-epi-props';
import { CoverageFormModel, declineCoverageReasonOther, GetNewHireCoverageValidationSchema, NewHireCoverageState, PlanTypes, DisplayLabels, DioApproverInitialValues, DeclinedValue } from '../models/coverage-models';
import { FormWrapper } from '../../../../../../global/components/form-wrapper';
import { PersonCoverage } from './person-coverage';
import { PlanSelectionItem } from './plan-selection-item';
import { DeskTopTierLabel } from './tier-labels-desktop';
import { SelfText } from '../../../../../annual-enrollment/models/annual-enrollment-models';
import { BenefitEnrollmentStep } from '../../models/pension-enrollment-models';
import { calculateTiers, GetAdminValidationModel, getBillingAccountInitialValuesForDioAdmin, GetCoveragePlanInitialValue, GetDioApproverInitialValues, GetCoveragePlanDependentsInitialValue, GetMemberSelectionRequiredValidationModel, GetNewHireConfirmationRedirectModel, onSubmit, ShouldShowAdminCafeteriaAcknowledgement, GetCoveragePlanBillingAccountInitialValues, itsCoverageFormUpdate, validatePlanContentDioApprover } from '../helpers/coverage-form-helpers';
import { DeskTopVolumeRateLabel } from './volume-rate-desktop';
import { setCurrentNewHireBenefitEnrollmentStep } from '../../slice/new-hire-enrollment-slices';
import { GetGpsType, GetPageButtonText, GetPageHeaderContent, GetPageHelperText, GetParticipantSelectionDescriptionText } from '../helpers/coverage-display-helpers';
import { useGpsType } from '../../../../../../global/hooks/useGpsType';
import { DividerSection } from '../../../../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../../../../global/components/layout/generic-content-spacer';
import { FormGroup } from '../../../../../../global/components/layout/form-group';
import { WysiwygWithReactLink } from '../../../../../../global/components/wysiwyg-with-react-link';
import { CoverageReview } from './coverage-review';
import { FormField } from '../../../../../../global/components/form-element/form-field';
import { getRemainingCharacterCounter } from '../../../mid-year/mid-year-helpers';
import { TcsmModal } from '../../../../../../global/components/tcsm-modal';
import { ButtonWrapper } from '../../../../../../global/components/layout/button-wrapper';
import { useBasePath } from '../../../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../../../constants/routes';
import { NewHireEnrollmentRoutes } from '../../models/new-hire-routes';
import { ConfirmationStatusCode, DioApproverConfirmationPageState, NewHireConfirmationRedirectModel } from '../../models/new-hire-confirmation-models';
import { WhoWillEnrollCriterias, WhoWillEnrollOptions } from '../../models/who-will-enroll-models';
import { parseLov } from '../../../../../../global/helpers/form-data-helper';
import { CalculatedTiers } from '../../models/new-hire-enrollment-models';
import { AnnualEnrollmentCoverageReviewDisplay } from './annual-enrollment-coverage-review-display';
import { buttonStyles } from '../../../../../../global/constants/theme/styles/components/buttonstyles';
import { getCurrentTimeNY, getNumberOfDays } from '../../../../../../global/helpers/date-helpers';
import { CoveragePageContentModel } from '../../../new-participant-enrollment/models/page-content-models';
import { isInstitutionOfficerOnly } from '../../../../../../global/helpers/auth-helpers';
import { useOnlyOtpEmployment } from '../../hooks/useNewhireEnrollmentAllowed';
import { AccountInfoRoutes } from '../../../../../account-info/constants/routes';
import { useEmploymentInfo } from '../../../employment/useEmployment';
import { postDioApproverRejectGhlForm } from '../../../../../../global/ducks/mlps-api';
import { AdminGhlPendingEnrollment } from '../../member/models/member-coverage-model';
import { clearLocalStorageSelections, verifyAndFillSelections } from '../../helpers/who-will-enroll-helpers';
import { getPendingEnrollmentLocalStorage, removePendingEnrollmentLocalStorage } from '../../member/benefit-enrollment/helper/diocese-approver-coverage-helper';
import { NewHireEventType } from '../../../../constants/constant-strings';
import { ShouldShowKaiserArbitration } from '../../../../../../global/helpers/kaiser';


interface Props {
	basePath: string;
	queryString: string;
	getEmployerIdHook: any;
	isParticipant?: boolean;
	customContentModel?: CoveragePageContentModel;
	confirmationCode?: ConfirmationStatusCode;
	getBillingAccountOwnerCn?: any;
	eventType?: string;
	isDioApprover?: boolean;
	qualifyingEventDateOverwrite?: string;
}



export function CoverageEnrollmentForm(props: Props) {

	const { basePath, queryString, getEmployerIdHook, isParticipant, customContentModel, confirmationCode, getBillingAccountOwnerCn, eventType, isDioApprover, qualifyingEventDateOverwrite } = props;
	useEmploymentInfo();

	const settings = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
	const aeSettings = useSelector<TcsmStates, AnnualEnrollmentProps>(state => state?.epiProps?.annualEnrollmentSettingsState?.epiContent);
	const employeeId = useSelector<TcsmStates, string>(state => state?.employmentState?.currentEmployee?.guid);
	const employerId = getEmployerIdHook();
	const displayTierMedical = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState?.tierToDisplayMedical);
	const displayTierDental = useSelector<TcsmStates, CalculatedTiers>(state => state?.newHireEnrollmentState?.tierToDisplayDental);
	const coverageState = useSelector<TcsmStates, NewHireCoverageState>(state => state?.newHireEnrollmentState.newHireCoverageState);
	const currentStep = useSelector<TcsmStates, BenefitEnrollmentStep>(state => state?.newHireEnrollmentState.currentEnrollmentStep);
	const whoWillEnroll = useSelector<TcsmStates, WhoWillEnrollCriterias>(state => state?.newHireEnrollmentState.whoWillEnrollCriteria);
	const hireDate = useSelector<TcsmStates, string>(state => state?.employmentState?.currentEmployment?.hire_date);
	const scheduledHoursUpdate = useSelector<TcsmStates, string>(state => state?.employmentState?.currentEmployment?.current_scheduled_hours_start_date);
	const [removeSelfDialogGroup, setRemoveSelfFlag] = useState<PlanTypes>(PlanTypes.None);
	const [reselectSelf, setReselectSelfFlag] = useState<PlanTypes>(PlanTypes.None);
	const [previousUrl, setPreviousUrl] = useState<string>(null);
	const history = useHistory();
	const dispatch = useDispatch();
	const labelSetting = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps.labelSettingState.epiContent);
	const app = React.useContext(DemographicsContext);
	const currentPerson = useSelector<TcsmStates, Person>(state => state?.personalInfo[app]?.currentPerson);
	const isLifeEventCoverageForm = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.isLifeEventCoverageForm);
	const gpsItem = useGpsType(GetGpsType(currentStep, customContentModel, isDioApprover, isLifeEventCoverageForm));
	const declineReasonLov = useSelector<TcsmStates, any>(state => state.lovProcState?.mlpsLov?.medicalDeclineReason);
	const declinedCoverageReasonOptions = declineReasonLov ? parseLov(declineReasonLov) : [];
	const localStoragePendingEnrollmentID = getPendingEnrollmentLocalStorage()?.id;
	const dioApproverValues: DioApproverInitialValues | null = isDioApprover ? GetDioApproverInitialValues(coverageState) : null;
	const currentDioApproverFormId = useSelector<TcsmStates, number>(state => state.newHireEnrollmentState?.dioApproverCurrentFormId ?? localStoragePendingEnrollmentID);
	const onlyOtp = useOnlyOtpEmployment();
	const buttonClasses = buttonStyles();
	const currentDate = getCurrentTimeNY();
	const billingAccountCn = getBillingAccountOwnerCn ? getBillingAccountOwnerCn() : null;
	const eventDate = itsCoverageFormUpdate(basePath) ? scheduledHoursUpdate : hireDate;
	const formattedEventDate = new Date(eventDate?.replace(/-/g, '/'));
	const numberOfDays = getNumberOfDays(currentDate, formattedEventDate);

	const institutionOfficerOnly = isInstitutionOfficerOnly();
	const requireApproval = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.enrollmentOptions?.require_approval);
	let confirmationLink = useBasePath(`${customContentModel?.confirmationRoute ?? `${ArcRoutes.ArcRoot}${ArcRoutes.NewHireEnrollment}${NewHireEnrollmentRoutes.Confirmation}`}?status=${confirmationCode ?? (institutionOfficerOnly ? ConfirmationStatusCode.PENDING : ConfirmationStatusCode.NH_BY_DIO)}`);
	const adminPendingGhlEnrollments = useSelector<TcsmStates, AdminGhlPendingEnrollment[]>(currentState => currentState?.newHireEnrollmentState?.adminGhlpendingEnrollments);

	const currentForminfo: AdminGhlPendingEnrollment = adminPendingGhlEnrollments?.find((form: AdminGhlPendingEnrollment) => form?.id === currentDioApproverFormId);
	let itsApproved = true;
	if (!isDioApprover && !isParticipant) {
		verifyAndFillSelections(whoWillEnroll);
	}

	const handleClose = () => {
		setPreviousUrl(null);
	};

	const confirmGoback = (url: string) => {
		history.push(url);
	};

	const onSuccess = (response) => {
		let dioApproverConfirmationPage: DioApproverConfirmationPageState | null = null;

		if (isDioApprover) {
			dioApproverConfirmationPage = { isDioApproverConfirmationPage: true, approvedState: itsApproved, currentForminfo };
			const confirmationStatus = itsApproved ? ConfirmationStatusCode.APPROVER_APPROVE : ConfirmationStatusCode.APPROVER_REJECT;
			confirmationLink = confirmationLink?.replace(ConfirmationStatusCode.NH_BY_DIO, confirmationStatus).replace(ArcRoutes.NewHireEnrollment, ArcRoutes.DioApproverEnrollment);
		}
		const confirmationPageModel: NewHireConfirmationRedirectModel = GetNewHireConfirmationRedirectModel(response);
		const updatedConfirmationPageModel = {
			...confirmationPageModel,
			dioApproverConfirmationPage,
		};
		clearLocalStorageSelections();
		removePendingEnrollmentLocalStorage();
		history.push(confirmationLink, updatedConfirmationPageModel);
	};

	const onCancel = () => {
		if (currentStep === BenefitEnrollmentStep.COVERAGE && !isDioApprover) {
			setPreviousUrl(`${basePath}${onlyOtp ? AccountInfoRoutes.RelationshipsSegment : NewHireEnrollmentRoutes.Pension}`);
		}

		if (currentStep === BenefitEnrollmentStep.COVERAGE && isDioApprover) {
			if (isLifeEventCoverageForm) {
				dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.RELATIONSHIP));
				setPreviousUrl(`${basePath}${AccountInfoRoutes.RelationshipsSegment}`);
				return;
			}
			dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.EMPLOYMENT));
			setPreviousUrl(`${basePath}${AccountInfoRoutes.EmploymentSegment}`);
			return;
		}

		if (isDioApprover && currentStep === BenefitEnrollmentStep.REVIEW) {
			itsApproved = false;
			dispatch(postDioApproverRejectGhlForm(currentDioApproverFormId, onSuccess));
		}

		dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.COVERAGE));
	};
	//Create initial object for formik initialValues for group life
	const ghlDefaultValues = (coverageState?.eligible_plans?.group_life?.plans || []).reduce((acc, glp) => ({ ...acc, [`volume${glp?.code}`]: '0' }), {});

	const initialValues: CoverageFormModel = {
		[PlanTypes.M]: isDioApprover ? dioApproverValues?.selectedMedicalPlan : GetCoveragePlanInitialValue(coverageState?.eligible_plans?.medical),
		[PlanTypes.D]: isDioApprover ? dioApproverValues?.selectedDentalPlan : GetCoveragePlanInitialValue(coverageState?.eligible_plans?.dental),
		[PlanTypes.G]: isDioApprover ? dioApproverValues?.selectedGroupPlan : GetCoveragePlanInitialValue(coverageState?.eligible_plans?.group_life),
		[PlanTypes.W]: isDioApprover ? dioApproverValues?.selectedStdPlan : GetCoveragePlanInitialValue(coverageState?.eligible_plans?.short_term_disability),
		[PlanTypes.L]: isDioApprover ? dioApproverValues?.selectedLtdPlan : GetCoveragePlanInitialValue(coverageState?.eligible_plans?.long_term_disability),
		[PlanTypes.U]: isDioApprover ? dioApproverValues?.selectedUeiPlan : GetCoveragePlanInitialValue(coverageState?.eligible_plans?.uei),
		M_billingAccountType: isDioApprover ? getBillingAccountInitialValuesForDioAdmin(dioApproverValues?.selectedMedicalBillingAccountNumber, coverageState?.eligible_plans?.medical) : GetCoveragePlanBillingAccountInitialValues(coverageState?.eligible_plans?.medical),
		D_billingAccountType: isDioApprover ? getBillingAccountInitialValuesForDioAdmin(dioApproverValues?.selectedDentalBillingAccountNumber, coverageState?.eligible_plans?.dental) : GetCoveragePlanBillingAccountInitialValues(coverageState?.eligible_plans?.dental),
		G_billingAccountType: isDioApprover ? getBillingAccountInitialValuesForDioAdmin(dioApproverValues?.selectedGroupBillingAccountNumber, coverageState?.eligible_plans?.group_life) : GetCoveragePlanBillingAccountInitialValues(coverageState?.eligible_plans?.group_life),
		W_billingAccountType: isDioApprover ? getBillingAccountInitialValuesForDioAdmin(dioApproverValues?.selectedLtdBillingAccountNumber, coverageState?.eligible_plans?.short_term_disability) : GetCoveragePlanBillingAccountInitialValues(coverageState?.eligible_plans?.short_term_disability),
		L_billingAccountType: isDioApprover ? getBillingAccountInitialValuesForDioAdmin(dioApproverValues?.selectedStdBillingAccountNumber, coverageState?.eligible_plans?.long_term_disability) : GetCoveragePlanBillingAccountInitialValues(coverageState?.eligible_plans?.long_term_disability),
		U_billingAccountType: isDioApprover ? getBillingAccountInitialValuesForDioAdmin(dioApproverValues?.selectedUeiBillingAccountNumber, coverageState?.eligible_plans?.uei) : GetCoveragePlanBillingAccountInitialValues(coverageState?.eligible_plans?.uei),
		medicalDependents: isDioApprover ? dioApproverValues?.medicalDependents : GetCoveragePlanDependentsInitialValue(coverageState?.eligible_plans?.medical),
		dentalDependents: isDioApprover ? dioApproverValues?.dentalDependents : GetCoveragePlanDependentsInitialValue(coverageState?.eligible_plans?.dental),
		M_member: whoWillEnroll?.medical === WhoWillEnrollOptions.member,
		D_member: whoWillEnroll?.dental === WhoWillEnrollOptions.member,

		W_member: whoWillEnroll?.std === WhoWillEnrollOptions.member,
		L_member: whoWillEnroll?.ltd === WhoWillEnrollOptions.member,

		medicalDeclineReason: isDioApprover ? dioApproverValues?.medicalDeclineReason : null,
		medicalDeclineReasonOther: isDioApprover ? dioApproverValues?.medicalDeclineReasonOther : null,
		dentalDeclineReason: isDioApprover ? dioApproverValues?.dentalDeclineReason : null,
		dentalDeclineReasonOther: isDioApprover ? dioApproverValues?.dentalDeclineReasonOther : null,

		memo: '',
		specialRequests: isDioApprover ? dioApproverValues?.specialRequests : '',
		agreement: false,
		kaiserArbitrationAgreement: false,
		cafeteriaAcknowledgement: false,
		...ghlDefaultValues,
	};

	const buttonText = GetPageButtonText(currentStep, settings, isDioApprover, isLifeEventCoverageForm);
	const pageHeader = GetPageHeaderContent(currentStep, settings, customContentModel, isDioApprover, isLifeEventCoverageForm);
	const submitHelperText = GetPageHelperText(currentStep, settings, isDioApprover, isLifeEventCoverageForm);
	const participantSelectionDescriptionText = GetParticipantSelectionDescriptionText(currentStep, settings, customContentModel);

	const handleDioApproverBannerNavigate = () => {
		const gridFwContent = document.getElementById('groupLifeReference');
		if (gridFwContent) {
			gridFwContent.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const handleBuildUrl = () => {
		return (
			<>
				<button className='link-button' type='button' onClick={() => handleDioApproverBannerNavigate()}>{settings?.dioceseApproverHeaderWarningUrlText}</button>
			</>
		);
	};

	const handleDioApproverBannerDescription = () => {
		if (!settings?.dioceseApproverHeaderWarningTitle) return null;

		const linkButton = handleBuildUrl();

		const placeholders = {
			'Link Text': linkButton,
		};

		const descriptionParts = settings.dioceseApproverHeaderWarningMessage.split(/\[(.*?)\]/g).map((part) => {
			return placeholders[part] || part;
		});

		return (
			<>
				<p>
					{descriptionParts}
				</p>
			</>
		);
	};

	const handleDioApproverBanner = () => {
		if (!isDioApprover) return null;

		if (isLifeEventCoverageForm) {
			return (
				<ContentSpacer>
					<Banner
						banner={{
							type: 'info',
							description: <WysiwygWithReactLink className='input-label' content={settings?.dioceseApproverLifeEventBannerMessage} />,
						}}
					/>
				</ContentSpacer>
			);
		}

		if (!coverageState?.eligible_plans?.group_life?.selected?.volume &&
			(coverageState?.eligible_plans?.group_life && coverageState?.eligible_plans?.group_life?.plans?.length > 0)) {

			return (
				<ContentSpacer>
					<Banner
						banner={{
							type: 'warning',
							label: <WysiwygWithReactLink className='input-label' content={settings?.dioceseApproverHeaderWarningTitle} />,
							description: handleDioApproverBannerDescription(),
						}}
					/>
				</ContentSpacer>
			);
		}

		return null;
	};

	const shouldDisableSubmit = (formProps: FormikProps<CoverageFormModel>) => {
		if (currentStep !== BenefitEnrollmentStep.REVIEW) {
			return false;
		}

		let disabled = !formProps?.values?.agreement;

		if (ShouldShowAdminCafeteriaAcknowledgement(coverageState, formProps?.values, numberOfDays)) {
			disabled = disabled || !formProps?.values?.cafeteriaAcknowledgement;
		}

		// Kaiser arbitration requirement: if Kaiser applies, checkbox must be checked
		const selectedMedicalPlanCode = coverageState?.eligible_plans?.medical?.current?.code || formProps?.values?.M;
		const personZip = currentPerson?.mailing_postal_code;
		const showKaiserArbitrationBase = ShouldShowKaiserArbitration({
			plans: coverageState?.eligible_plans?.medical?.plans,
			code: selectedMedicalPlanCode,
			personZip,
		});
		const baselineMedicalPlanCode = coverageState?.eligible_plans?.medical?.current?.code ?? (formProps?.initialValues as CoverageFormModel)?.M;
		const planChanged = !!selectedMedicalPlanCode && selectedMedicalPlanCode !== baselineMedicalPlanCode;
		const requireKaiserForApprover = isDioApprover ? (planChanged && showKaiserArbitrationBase) : showKaiserArbitrationBase;

		if (requireKaiserForApprover) {
			disabled = disabled || !formProps?.values?.kaiserArbitrationAgreement;
		}

		return disabled;
	};

	const hasMedical = coverageState?.eligible_plans?.medical?.plans?.length > 0;
	const hasDental = coverageState?.eligible_plans?.dental?.plans?.length > 0;
	const adminValidationModel = GetAdminValidationModel(coverageState);
	const memberValidationModel = GetMemberSelectionRequiredValidationModel(coverageState, whoWillEnroll, adminValidationModel);

	const validationSchema = GetNewHireCoverageValidationSchema(
		memberValidationModel,
		aeSettings,
		settings,
		labelSetting,
		hasMedical,
		adminValidationModel,
		coverageState?.eligible_plans?.group_life,
		institutionOfficerOnly,
		validatePlanContentDioApprover(coverageState?.eligible_plans?.medical, isDioApprover),
	);

	useEffect(() => {
		dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.COVERAGE));
		if (coverageState?.eligible_plans?.medical) {
			calculateTiers(
				coverageState?.eligible_plans?.medical,
				[SelfText].concat(coverageState?.eligible_dependents?.map(d => d?.guid)),
				dispatch,
				coverageState?.eligible_dependents,
				PlanTypes.M,
				isDioApprover,
			);
		}
		if (coverageState?.eligible_plans?.dental) {
			calculateTiers(
				coverageState?.eligible_plans?.dental,
				[SelfText].concat(coverageState?.eligible_dependents?.map(d => d?.guid)),
				dispatch,
				coverageState?.eligible_dependents,
				PlanTypes.D,
				isDioApprover,
			);
		}
	}, [coverageState]);

	function RenderNoCoverageReasonOther(formProps: FormikProps<CoverageFormModel>, fieldName: string, otherFieldName: string) {
		if (formProps?.values[fieldName] !== declineCoverageReasonOther) return null;

		return (
			<>
				<p className='custom-sublabel'>{settings?.declineCoverageReasonSelectMessage}</p>
				<FormField
					name={otherFieldName}
					label={aeSettings.declineMedicalCoverageReasonOtherLabel}
					component='input'
					multiline
					rows={5}
					touched={formProps.touched}
					errors={formProps.errors}
					required
				/>
			</>
		);
	}

	function RenderNoCoverageReason(
		formProps: FormikProps<CoverageFormModel>,
		selectedMedicalPlan: string,
		fieldName: string,
		otherFieldName: string,
		memberEnroll: boolean,
		displayPlanSelectionDioApprover: boolean,
	) {
		if ((selectedMedicalPlan !== DeclinedValue) || memberEnroll) return null;

		if (selectedMedicalPlan !== DeclinedValue) return null;

		if (!displayPlanSelectionDioApprover) return null;

		return (
			<div className='grid-nested'>
				<div className='grid-main-content'>

					<DividerSection greySection>
						<ContentSpacer>
							<h2>{settings.declineCoverageReasonGroupTitle}<span className='red-text'>*</span></h2>
						</ContentSpacer>
						<FormGroup>
							<div className='form-item'>
								<FormField
									name={fieldName}
									label={settings.declineCoverageReasonSelectLabel}
									component='input'
									options={declinedCoverageReasonOptions}
									errors={formProps.errors}
									touched={formProps.touched}
									select
									required
									placeholder={settings.declineCoverageReasonSelectPlaceHolder}
								/>

							</div>
							{RenderNoCoverageReasonOther(formProps, fieldName, otherFieldName)}
						</FormGroup>
					</DividerSection>
				</div>
			</div>
		);
	}



	function RenderCoveragePerson(formProps: FormikProps<CoverageFormModel>) {
		if (currentStep === BenefitEnrollmentStep.REVIEW) {
			return null;
		}

		if (whoWillEnroll?.medical === WhoWillEnrollOptions.member && whoWillEnroll?.dental === WhoWillEnrollOptions.member) {
			return null;
		}

		if (!hasMedical && !hasDental) {
			return null;
		}

		return (
			<div className='grid-main-content'>
				<DividerSection removeDivider >
					<ContentSpacer>
						{handleDioApproverBanner()}
						<WysiwygWithReactLink content={participantSelectionDescriptionText} />
					</ContentSpacer>
					<FormGroup>
						{
							whoWillEnroll?.medical !== WhoWillEnrollOptions.member && hasMedical &&
							<ContentSpacer>
								<PersonCoverage
									planType={PlanTypes.M}
									fieldName='medicalDependents'
									groupLabel={settings?.medicalCoverageText}
									settings={settings}
									formProps={formProps}
									eligibleDependents={coverageState?.eligible_dependents}
									plan={coverageState?.eligible_plans?.medical}
									setRemoveSelfFlag={setRemoveSelfFlag}
									setReselectSelfFlag={setReselectSelfFlag}
									removeSelfDialogGroup={removeSelfDialogGroup}
									reselectSelf={reselectSelf}
									displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.medical, isDioApprover)}
								/>
							</ContentSpacer>
						}
						{
							whoWillEnroll?.dental !== WhoWillEnrollOptions.member && hasDental &&
							<PersonCoverage
								planType={PlanTypes.D}
								fieldName='dentalDependents'
								groupLabel={settings?.dentalCoverageText}
								settings={settings}
								formProps={formProps}
								eligibleDependents={coverageState?.eligible_dependents}
								plan={coverageState?.eligible_plans?.dental}
								setRemoveSelfFlag={setRemoveSelfFlag}
								setReselectSelfFlag={setReselectSelfFlag}
								removeSelfDialogGroup={removeSelfDialogGroup}
								reselectSelf={reselectSelf}
								displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.dental, isDioApprover)}
							/>
						}
					</FormGroup>
				</DividerSection>
			</div>
		);
	}

	function RenderPlans(formProps: FormikProps<CoverageFormModel>) {
		if (currentStep === BenefitEnrollmentStep.REVIEW) {
			return <CoverageReview
				settings={settings}
				labelSettings={labelSetting}
				formProps={formProps}
				setEditUrl={setPreviousUrl}
				basePath={basePath}
				isParticipant={isParticipant}
				isDioApprover={isDioApprover}
				qualifyingEventDateOverwrite={qualifyingEventDateOverwrite}
			/>;
		}

		return (
			<>
				{
					coverageState?.eligible_plans?.medical &&
					<>
						<PlanSelectionItem
							memberEnroll={whoWillEnroll?.medical === WhoWillEnrollOptions.member}
							formikProps={formProps}
							componentModel={
								{
									formPlanTypeName: PlanTypes.M,
									planTypeName: settings?.medicalPlanTitle,
									planNamesLabel: settings?.medicalPlansLabel,
									settings,
									labelSettings: labelSetting,
									declineOptionText: settings?.declineMedicalPlanOptionText,
								}
							}
							plans={coverageState?.eligible_plans?.medical}
							radioTableLabels={<DeskTopTierLabel settings={settings} tiers={coverageState?.eligible_plans?.medical?.plans[0]?.rates_by_tier} />}
							setRemoveSelfFlag={setRemoveSelfFlag}
							tierKey='tierToDisplayMedical'
							noPlanOfferMessage={settings?.noPlanOfferMessage}
							displayLabels={DisplayLabels.MEDICALDENTAL}
							eligibleDependents={coverageState?.eligible_dependents}
							isDioApprover={isDioApprover}
							displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.medical, isDioApprover)}
						/>
						{
							RenderNoCoverageReason(
								formProps,
								formProps?.values?.M,
								'medicalDeclineReason',
								'medicalDeclineReasonOther',
								whoWillEnroll?.medical === WhoWillEnrollOptions.member,
								validatePlanContentDioApprover(coverageState?.eligible_plans?.medical, isDioApprover),
							)
						}
					</>
				}
				{
					coverageState?.eligible_plans?.dental &&
					<>
						<PlanSelectionItem
							memberEnroll={whoWillEnroll?.dental === WhoWillEnrollOptions.member}
							formikProps={formProps}
							componentModel={
								{
									formPlanTypeName: PlanTypes.D,
									planTypeName: settings?.dentalPlanTitle,
									planNamesLabel: settings?.dentalPlansLabel,
									settings,
									labelSettings: labelSetting,
									declineOptionText: settings?.declineDentalPlanOptionText,
								}
							}
							plans={coverageState?.eligible_plans?.dental}
							radioTableLabels={<DeskTopTierLabel settings={settings} tiers={coverageState?.eligible_plans?.dental?.plans[0]?.rates_by_tier} />}
							setRemoveSelfFlag={setRemoveSelfFlag}
							tierKey='tierToDisplayDental'
							noPlanOfferMessage={settings?.noPlanOfferMessage}
							displayLabels={DisplayLabels.MEDICALDENTAL}
							eligibleDependents={coverageState?.eligible_dependents}
							isDioApprover={isDioApprover}
							displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.dental, isDioApprover)}
						/>
					</>
				}
				{
					coverageState?.eligible_plans?.group_life &&
					<PlanSelectionItem
						memberEnroll={false}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.G,
								planTypeName: settings?.groupLifePlanTitle,
								planNamesLabel: settings?.groupLifePlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineGroupLifePlanOptionText,
							}
						}
						plans={coverageState?.eligible_plans?.group_life}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.VOLUMERATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.VOLUMERATE}
						isDioApprover={isDioApprover}
						displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.group_life, isDioApprover)}
					/>
				}
				{
					coverageState?.eligible_plans?.short_term_disability &&
					<PlanSelectionItem
						memberEnroll={whoWillEnroll?.std === WhoWillEnrollOptions.member}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.W,
								planTypeName: settings?.shortDisPlanTitle,
								planNamesLabel: settings?.shortDisPlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineShortDisPlanOptionText,
							}
						}
						plans={coverageState?.eligible_plans?.short_term_disability}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.RATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.RATE}
						showPlanCodeInName
						displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.short_term_disability, isDioApprover)}
					/>
				}
				{
					coverageState?.eligible_plans?.long_term_disability &&
					<PlanSelectionItem
						memberEnroll={whoWillEnroll?.ltd === WhoWillEnrollOptions.member}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.L,
								planTypeName: settings?.longDisPlanTitle,
								planNamesLabel: settings?.longDisPlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineLongDisPlanOptionText,
							}
						}
						plans={coverageState?.eligible_plans?.long_term_disability}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.RATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.RATE}
						showPlanCodeInName
						displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.long_term_disability, isDioApprover)}
					/>
				}
				{
					coverageState?.eligible_plans?.uei &&
					<PlanSelectionItem
						memberEnroll={false}
						formikProps={formProps}
						componentModel={
							{
								formPlanTypeName: PlanTypes.U,
								planTypeName: settings?.ueiPlanTitle,
								planNamesLabel: settings?.ueiPlansLabel,
								settings,
								labelSettings: labelSetting,
								declineOptionText: settings?.declineUeiPlanOptionText,
							}
						}
						plans={coverageState?.eligible_plans?.uei}
						radioTableLabels={<DeskTopVolumeRateLabel settings={settings} labels={DisplayLabels.RATE} />}
						noPlanOfferMessage={settings?.noPlanOfferMessage}
						displayLabels={DisplayLabels.RATE}
						showPlanCodeInName
						displayPlanSelectionDioApprover={validatePlanContentDioApprover(coverageState?.eligible_plans?.uei, isDioApprover)}
					/>
				}
				<div className='grid-main-content'>
					<DividerSection removeDivider>
						<AnnualEnrollmentCoverageReviewDisplay
							formikProps={formProps}
							plans={coverageState}
							settings={settings}
							dioApproverMedicalPlansDisplayed={validatePlanContentDioApprover(coverageState?.eligible_plans?.medical, isDioApprover)}
							dioApproverDentalPlansDisplayed={validatePlanContentDioApprover(coverageState?.eligible_plans?.dental, isDioApprover)}
							dioApproverShortTermPlansDisplayed={validatePlanContentDioApprover(coverageState?.eligible_plans?.short_term_disability, isDioApprover)}
							dioApproverLongTermPlansDisplayed={validatePlanContentDioApprover(coverageState?.eligible_plans?.long_term_disability, isDioApprover)}
							dioApproverUeiPlansDisplayed={validatePlanContentDioApprover(coverageState?.eligible_plans?.uei, isDioApprover)}
						/>
					</DividerSection>
				</div>
				<div className='grid-main-content'>
					<DividerSection removeDivider>
						<FormGroup>
							<ContentSpacer>

								<FormField
									name='memo'
									label={settings?.myNoteLabel}
									component='input'
									multiline
									rows={5}
									touched={formProps.touched}
									errors={formProps.errors}
								/>
								<Grid container justifyContent='flex-end'>
									<p className='input-caption'>{`${getRemainingCharacterCounter(formProps?.values?.memo?.length)}/255 ${settings.characterLimitText || ''}`}</p>
								</Grid>
							</ContentSpacer>

							<p><strong>{settings?.specialRequestTitle}</strong></p>
							<p>{settings.specialRequestDescription}</p>
							<FormField
								name='specialRequests'
								component='input'
								multiline
								rows={5}
								touched={formProps.touched}
								errors={formProps.errors}
							/>
							<Grid container justifyContent='flex-end'>
								<p className='input-caption'>{`${getRemainingCharacterCounter(formProps?.values?.specialRequests?.length)}/255 ${settings.characterLimitText || ''}`}</p>
							</Grid>
						</FormGroup>
					</DividerSection>
				</div>
			</>
		);
	}

	function RenderFormContent(formProps: FormikProps<CoverageFormModel>) {

		return (
			<>
				<div className='grid-main-content'>
					<PageHeader
						headerText={pageHeader?.title}
						description={pageHeader?.description} />
					{
						isInstitutionOfficerOnly ?
							<ContentSpacer>
								<WysiwygWithReactLink content={settings?.coverageDiocesanAdministratorApprovalMessage} />
							</ContentSpacer>
							:
							null
					}

					<Hidden mdUp>
						<SideBarContent>
							<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
						</SideBarContent>
					</Hidden>
					{
						RenderCoveragePerson(formProps)
					}
				</div>
				<Hidden smDown>
					<div className='grid-sidebar'>
						<SideBarContent>
							<GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
						</SideBarContent>
					</div>
				</Hidden>


			</>
		);

	}

	return (
		<Formik
			initialValues={initialValues}
			validateOnBlur={false}
			validateOnChange={false}
			onSubmit={(values) => onSubmit(
				dispatch,
				currentStep,
				values,
				coverageState,
				employeeId,
				employerId,
				whoWillEnroll,
				onSuccess,
				displayTierMedical,
				displayTierDental,
				eventType,
				eventDate,
				queryString,
				billingAccountCn,
				institutionOfficerOnly || requireApproval,
				isDioApprover,
				currentDioApproverFormId,
			)}
			enableReinitialize
			validationSchema={validationSchema}
		>
			{(formProps: FormikProps<CoverageFormModel>) =>
				<Form className='grid-fw-content grid-nested'>
					{
						RenderFormContent(formProps)
					}
					<FormWrapper
						formikProps={formProps}
						submitText={buttonText?.continue}
						cancelText={buttonText?.prev}
						onCancel={onCancel}
						preventButtonDisableValidation
						helperText={submitHelperText}
						altCancelButton={isDioApprover}
						submitDisabled={shouldDisableSubmit(formProps)}>
						{
							RenderPlans(formProps)
						}
					</FormWrapper>
					<TcsmModal
						open={previousUrl != null}
						handleClose={handleClose}>
						<>
							<h2>{aeSettings.previousStepModalTitle}</h2>
							<div dangerouslySetInnerHTML={{ __html: aeSettings?.previousStepModalDescription }} />
							<ButtonWrapper flexEnd>
								<button type='button' className={buttonClasses.tertiaryButton} onClick={handleClose}>{aeSettings?.previousStepModalCancel}</button>
								<button type='button' className={buttonClasses.primaryButton} onClick={() => confirmGoback(previousUrl)} >{aeSettings?.previousStepModalConfirm}</button>
							</ButtonWrapper>
						</>

					</TcsmModal>
				</Form>}
		</Formik>
	);
}

CoverageEnrollmentForm.defaultProps = {
	isParticipant: false,
	customContentModel: null,
	confirmationCode: null,
	getBillingAccountOwnerCn: null,
	eventType: NewHireEventType,
	isDioApprover: false,
	qualifyingEventDateOverwrite: null,
};


